// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const users = gql`
  query users(
    $where: UserWhereInput
    $orderBy: UserOrderByInput
    $skip: Int
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    users(
      where: $where
      orderBy: $orderBy
      skip: $skip
      after: $after
      before: $before
      first: $first
      last: $last
    ) @rest(type: "User", path: "user/?{args}") {
      id
      userName
      password
      language
      fullName
      description
      phoneNumber
      email
      autoSaveNonSavedPanels
      autoSaveSavedPanels
      showSeconds
      restoreLastState
      trendViewType
      defaultGraphicBackgroundColor
      defaultAxisBackgroundColor
      defaultLegendBackgroundColor
      defaultForecastBackgroundColor
      defaultLegendFontColor
      defaultTimeAxisColor
      trendCsvSeparator
      showAlarms
      showEvents
      showNodeId
      installPlausibilityRulesByDefault
      defaultselectautocreateforecastsensors
      defaultselectforecast
      cropFirstStageDay
      cropFirstStageMonth
      showCropMenu
      invisibleCrops
      createExtensionsAfterCropCreated
      showAdvancedSettings
      invisibleExtensions
      defaultMaxEventAgeForecast
      notificationOnForecastActive
      unitType
      convtablestring
      permissionOwner
      permissionGroup
      permissionOther
      sessionTimeout
      authrequireduserlevel
      instantmessengerid
      instantmessengerproviderid
      locked
      autoscroll
      fontFamily
      fontSize
      refreshInterval
      restoreprevious
      showlinenum
      tabplacement
      licenseAgreementAcceptanceDate
      agbConfirmed
    }

    userCount @defer @rest(type: "Int", path: "user/count")
  }
`;

export default users;
